import React from 'react';
import './graphStyles.scss'




export function GraphDropDown({ display, currentWeek, setCurrentWeek, weeks}) {

    const [open, setOpen] = React.useState(false);

    // Listener for dropdown animation
    const [dropDownClicked, setDropDownClicked] = React.useState(false)

    function handleToggleDropDown() {
        /* Handles drop down animation function */
        if (!open) { setDropDownClicked(true) }
        else { setDropDownClicked(false) }
        setOpen(!open);
    }

    function closeDropDownOnBlur() {
        if (open) {
            handleToggleDropDown()
        }
    }
    
    function changeCurrentWeek(currentWeekNumber) {
        setCurrentWeek(currentWeekNumber)
    }


    return (
      <div className={`${display === "dashboard" ? "hidden" : "visible"}`}>
        {/* <-- Drop down button --> */}
        {display === "firstlasttouch" ? (
          <button
            className="dropdown__button__touch"
            onClick={handleToggleDropDown}
            onBlur={closeDropDownOnBlur}
          >
            {weeks?.length >= currentWeek - 1 ? weeks[currentWeek] : ""}
            {open ? (
              <div className="dropdown__arrow__up"></div>
            ) : (
              <div className="dropdown__arrow__down"></div>
            )}
          </button>
        ) : (
          <button
            className="dropdown__button"
            onClick={handleToggleDropDown}
            onBlur={closeDropDownOnBlur}
          >
            (WEEK OF {weeks?.length >= currentWeek - 1 && weeks[currentWeek]})
            {open ? (
              <div className="dropdown__arrow__up"></div>
            ) : (
              <div className="dropdown__arrow__down"></div>
            )}
          </button>
        )}

        {weeks?.length === 0 ? (
          <div></div>
        ) : (
          <div>
            {/* Dropdown arrow */}
            <div
              className={`dropdown__display__pointer ${
                open ? "visible" : "hidden"
              } ${
                display === "firstlasttouch" ? "dropdown__pointer__touch" : ""
              }`}
              style={{ zIndex: "5" }}
            />

            {/* <-- Drop down display --> */}
            <div
              className={`dropdown__display ${open ? "visible" : "hidden"} ${
                dropDownClicked ? "dropdown__animation" : ""
              } ${
                display === "marketing analytics" ? "dropdown__analytics" : ""
              } ${
                display === "firstlasttouch" ? "dropdown__display__touch" : ""
              }`}
              style={{ zIndex: "4" }}
            >
              {display === "firstlasttouch" ? (
                <div>
                  {weeks?.map((week, index) => (
                    <button
                      data-week={index}
                      key={index}
                      className="dropdown__item__touch"
                      onMouseDown={(e) =>
                        changeCurrentWeek(e.target.dataset.week)
                      }
                    >
                      {week}
                    </button>
                  ))}
                </div>
              ) : (
                <div>
                  {weeks.map((week, index) => (
                    <button
                      data-week={index}
                      key={index}
                      className="dropdown__item"
                      onMouseDown={(e) =>
                        changeCurrentWeek(e.target.dataset.week)
                      }
                    >
                      (WEEK OF {week.replaceAll("/", "-")})
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
}